import router from '../router'
import axios from "axios";
import store from "./index";

export default {
    namespaced: true,
    state: {
        authenticated: false,
        user: {},
        token: null,
        settings: {
            with_edge_sizes: false,
            show_edge_sides_count: false,
            allow_no_price: false
        }
    },
    getters: {
        authenticated(state) {
            return state.authenticated
        },
        user(state) {
            return state.user
        },
        token(state) {
            return state.token
        },
        settings(state) {
            return state.settings
        }
    },
    mutations: {
        SET_AUTHENTICATED(state, value) {
            state.authenticated = value
        },
        SET_USER(state, value) {
            state.user = value
            if (value.settings) {
                state.settings = value.settings
            }
        },
        SET_TOKEN(state, value) {
            state.token = value
        },
        SET_SETTINGS(state, value) {
            state.settings = value
        }
    },
    actions: {
        async login({ commit, dispatch }, data) {
            commit('SET_TOKEN', data.token)
            commit('SET_USER', data.user)
            commit('SET_AUTHENTICATED', true)
            axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.auth.token}`;

            // Загружаем цвета после успешной авторизации
            await dispatch('data/loadColors', null, { root: true })

            router.push({ name: 'Main' })
        },
        logout({ commit }) {
            commit('SET_USER', {})
            commit('SET_TOKEN', null)
            commit('SET_AUTHENTICATED', false)
        },
        async loadUserData({ commit }) {
            try {
                const response = await axios.get('/user/my')
                const userData = response.data.data
                commit('SET_USER', userData)
                return userData
            } catch (error) {
                console.error('Error loading user data:', error)
                return null
            }
        }
    }
}